module.exports = __webpack_public_path__ + "static/media/Quick Magic cocoa drink(1).4cb07482.png";